module.exports = __webpack_public_path__ + "img/grown.58b7ac04.png";